export const daAttivareFilterButtons = [
    {text: "Numero di telefono", value: "msisdn"},
    {text: "Numero seriale", value: "iccId"}
]

export const daAttivareSortingOptions = [
    {text: "Numero di telefono", value: "msisdn"},
    {text: "Numero seriale", value: "iccId"}
]

export const filterDaAttivare = {
    msisdn: {
        label: "Numero di telefono",
        value: "",
    },
    iccId: {
        label: "Numero seriale",
        value: "",
    },
}